import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WeatherEventsPage } from './weather-events';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    WeatherEventsPage,
  ],
  imports: [
    IonicPageModule.forChild(WeatherEventsPage),
    DirectivesModule,
  ],
})
export class WeatherEventsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/weather-readings/weather-events/weather-events.module.ts